
import angular from 'angular';

import dateFormat from './date-format';

export default angular.module('directive.date-format', [])
	.directive('dateFormat', dateFormat)
	.name;



// WEBPACK FOOTER //
// ./src/directive/date-format/index.js